import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { InvoicePdfDeliveryRunStatus, PendingInvoicePdfDelivery, RetryInvoicePdfDeliveriesResult } from '../interfaces/pending-invoice-pdf-delivery.interface';

@Injectable({
	providedIn: 'root',
})
export class InvoicePdfDeliveryService {
	constructor(private http: HttpClient) {}

	getPending(linkId: number): Observable<PendingInvoicePdfDelivery[]> {
		return this.http.get<PendingInvoicePdfDelivery[]>(this.getBaseUrl(linkId)).pipe(
			map(deliveries => deliveries.map(delivery => this.mapDates(delivery)))
		);
	}

	getAvailability(linkId: number): Observable<{ enabled: boolean; pendingCount: number }> {
		return this.http.get<{ enabled: boolean; pendingCount: number }>(`${this.getBaseUrl(linkId)}/availability`);
	}

	getRunStatus(linkId: number): Observable<InvoicePdfDeliveryRunStatus> {
		return this.http.get<InvoicePdfDeliveryRunStatus>(`${this.getBaseUrl(linkId)}/run-status`).pipe(
			map(status => ({
				...status,
				createdAtUtc: status.createdAtUtc ? new Date(status.createdAtUtc) : null,
				executeAtUtc: status.executeAtUtc ? new Date(status.executeAtUtc) : null,
			}))
		);
	}

	cancel(linkId: number, deliveryId: number): Observable<void> {
		return this.http.delete<void>(`${this.getBaseUrl(linkId)}/${deliveryId}`);
	}

	retry(linkId: number, deliveryId: number): Observable<PendingInvoicePdfDelivery> {
		return this.http.post<PendingInvoicePdfDelivery>(`${this.getBaseUrl(linkId)}/${deliveryId}/retry`, {}).pipe(
			map(delivery => this.mapDates(delivery))
		);
	}

	retryMany(linkId: number, deliveryIds: number[]): Observable<RetryInvoicePdfDeliveriesResult> {
		return this.http.post<RetryInvoicePdfDeliveriesResult>(`${this.getBaseUrl(linkId)}/retry`, {
			deliveryIds,
			all: false,
		});
	}

	retryAll(linkId: number): Observable<RetryInvoicePdfDeliveriesResult> {
		return this.http.post<RetryInvoicePdfDeliveriesResult>(`${this.getBaseUrl(linkId)}/retry`, {
			deliveryIds: [],
			all: true,
		});
	}

	private getBaseUrl(linkId: number): string {
		return `links/${linkId}/invoice-pdf-deliveries`;
	}

	private mapDates(delivery: PendingInvoicePdfDelivery): PendingInvoicePdfDelivery {
		return {
			...delivery,
			creationDateUtc: new Date(delivery.creationDateUtc),
			nextAttemptAtUtc: delivery.nextAttemptAtUtc ? new Date(delivery.nextAttemptAtUtc) : null,
			leaseExpiresAtUtc: delivery.leaseExpiresAtUtc ? new Date(delivery.leaseExpiresAtUtc) : null,
		};
	}
}
